import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { VariantProps } from "class-variance-authority";
import type { SubMenu as SubMenuType } from "@/types";
import { menuItemVariants } from "./MenuItem";
import { Link } from "@/components/ui/Link";
export interface SubMenuProps {
  /** Sub-menu data containing label and items */
  data: SubMenuType;
  /** Visual variant */
  variant?: VariantProps<typeof menuItemVariants>["variant"];
  /** Whether the sub-menu is currently active (contains the active link) */
  isActive?: boolean;
}
export const SubMenuTrigger: React.FC<SubMenuProps> = t0 => {
  const $ = _c(13);
  const {
    data,
    variant,
    isActive
  } = t0;
  if (data.href) {
    const t1 = data.href;
    const t2 = data.label;
    let t3;
    if ($[0] !== variant) {
      t3 = menuItemVariants({
        variant
      });
      $[0] = variant;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== data.href || $[3] !== data.label || $[4] !== isActive || $[5] !== t3) {
      t4 = <Link href={t1} label={t2} isActive={isActive} className={t3} />;
      $[2] = data.href;
      $[3] = data.label;
      $[4] = isActive;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const t1 = isActive ? "page" : undefined;
  let t2;
  if ($[7] !== variant) {
    t2 = menuItemVariants({
      variant
    });
    $[7] = variant;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== data.label || $[10] !== t1 || $[11] !== t2) {
    t3 = <button type="button" aria-current={t1} className={t2}>{data.label}</button>;
    $[9] = data.label;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};